import { render, staticRenderFns } from "./SecurityGuardPriceList.vue?vue&type=template&id=2b87e699&"
import script from "./SecurityGuardPriceList.vue?vue&type=script&lang=js&"
export * from "./SecurityGuardPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports